import { Pipe, PipeTransform } from '@angular/core';

import { isUserAllowedToAccessAllProducts } from 'src/app/user/constants/constants';

@Pipe({ name: 'isUserAllowedToAccessAllProducts', standalone: true })
export class IsUserAllowedToAccessAllProductsPipe implements PipeTransform {
  transform(section: string, userData: any): boolean {
    return isUserAllowedToAccessAllProducts(section, userData);
  }
}
